export default __webpack_public_path__ + "static/colors-spread-7ee85311ce3a989010554cfd60b128c7.jpg";